import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiCheckCircle,
  FiXCircle,
  FiRefreshCw,
  FiDownload,
  FiEye,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function KYCReviewQueue() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("pending");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [kycCases] = useState([
    {
      id: 1,
      userId: "USR-001",
      userName: "Rajesh Kumar",
      email: "rajesh@example.com",
      submittedDate: "2024-01-20",
      documentType: "PAN + Aadhaar",
      status: "Pending",
      priority: "High",
    },
    {
      id: 2,
      userId: "USR-002",
      userName: "Priya Sharma",
      email: "priya@example.com",
      submittedDate: "2024-01-19",
      documentType: "PAN + Aadhaar + Bank Statement",
      status: "Pending",
      priority: "Medium",
    },
    {
      id: 3,
      userId: "USR-003",
      userName: "Amit Patel",
      email: "amit@example.com",
      submittedDate: "2024-01-18",
      documentType: "PAN + Aadhaar",
      status: "Pending",
      priority: "Low",
    },
  ]);

  const handleApprove = (caseId) => {
    Swal.fire({
      title: "Approve KYC?",
      text: "Are you sure you want to approve this KYC submission?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Approved!", "KYC has been approved successfully.", "success");
      }
    });
  };

  const handleReject = (caseId) => {
    Swal.fire({
      title: "Reject KYC",
      html: `
        <input id="rejectionReason" class="swal2-input" placeholder="Enter rejection reason..." required>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Reject",
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#3085d6",
      preConfirm: () => {
        const reason = document.getElementById("rejectionReason").value;
        if (!reason) {
          Swal.showValidationMessage("Please enter a rejection reason");
        }
        return reason;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Rejected!", `KYC rejected. Reason: ${result.value}`, "info");
      }
    });
  };

  const handleRequestReupload = (caseId) => {
    Swal.fire({
      title: "Request Re-upload",
      html: `
        <input id="reuploadReason" class="swal2-input" placeholder="Enter reason for re-upload request...">
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Send Request",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Request Sent!", "User will be notified to re-upload documents.", "success");
      }
    });
  };

  const filteredCases = kycCases.filter((kycCase) => {
    const matchesSearch =
      kycCase.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      kycCase.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      kycCase.userId.includes(searchTerm);
    return matchesSearch;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCases.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredCases.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                  <div className="content-page-header content-page-headersplit">
                <h5>KYC Review Queue</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/users/directory">Users</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    KYC Review Queue
                  </li>
                </ol>
              </nav>
          
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Filters */}
                <div className="row g-2 flex-grow-1">
                  {/* Search */}
                  <div className="col-12 col-md-6">
                    <div className="position-relative">
                      <FiSearch
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#64748b",
                          zIndex: 1,
                        }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by name, email, or user ID..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setCurrentPage(0);
                        }}
                        style={{ paddingLeft: "40px" }}
                      />
                    </div>
                  </div>

                  {/* Status Filter */}
                  <div className="col-12 col-md-3">
                    <select
                      className="form-control"
                      value={statusFilter}
                      onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                    >
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button className="btn btn-primary">
                    {/* <FiDownload className="me-2" /> */}
                    Export
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>User ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Submitted Date</th>
                          <th>Documents</th>
                          <th>Priority</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="7">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((kycCase) => (
                            <tr key={kycCase.id}>
                              <td style={{ fontWeight: "500" }}>{kycCase.userId}</td>
                              <td style={{ fontWeight: "500" }}>{kycCase.userName}</td>
                              <td>{kycCase.email}</td>
                              <td>{kycCase.submittedDate}</td>
                              <td>{kycCase.documentType}</td>
                              <td>
                                <span className={kycCase.priority === "High" ? "badge-pending" : kycCase.priority === "Medium" ? "badge-pending" : "badge-active"}>
                                  {kycCase.priority}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    title="View Documents"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleApprove(kycCase.id)}
                                    title="Approve"
                                    style={{ cursor: "pointer", color: "#10b981" }}
                                  >
                                    <i className="fas fa-check-circle"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleReject(kycCase.id)}
                                    title="Reject"
                                    style={{ cursor: "pointer", color: "#ef4444" }}
                                  >
                                    <i className="fas fa-times-circle"></i>
                                  </div>
                                  <div
                                    className="delete-table"
                                    onClick={() => handleRequestReupload(kycCase.id)}
                                    title="Request Re-upload"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-redo"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
